<template>
  <div class="layout-host">
    <div v-if="forcePasswordMode" class="force-password-shell">
      <router-view />
    </div>
    <el-container v-else class="layout-root">
    <el-aside width="220px" class="aside">
      <div class="logo">
        <span class="logo-badge">安</span>
        <div v-if="showProjectGroupSelect" class="logo-body">
          <el-select
            :value="selectedProjectGroupId"
            size="mini"
            class="project-group-select"
            :disabled="projectGroupOptions.length <= 1"
            popper-class="project-group-popper"
            @change="onProjectGroupChange"
          >
            <el-option
              v-for="opt in projectGroupOptions"
              :key="opt.id"
              :label="opt.name"
              :value="opt.id"
            />
          </el-select>
          <span v-if="adminDisplayName" class="logo-admin">{{ adminDisplayName }}</span>
        </div>
        <span v-else class="logo-text">{{ logoText }}</span>
      </div>
      <el-menu
        :default-active="menuActivePath"
        router
        @select="handleMenuSelect"
        background-color="transparent"
        text-color="#c8d3e6"
        active-text-color="#ffffff"
        class="side-menu"
      >
        <el-menu-item v-if="can(PERM.DASHBOARD_VIEW)" index="/dashboard">
          <i class="el-icon-data-analysis"></i><span>任务总览</span>
        </el-menu-item>
        <el-menu-item v-if="can(PERM.USERS_MANAGE)" index="/projects">
          <i class="el-icon-office-building"></i><span>项目管理</span>
        </el-menu-item>
        <el-menu-item v-if="can(PERM.USERS_MANAGE)" index="/users">
          <i class="el-icon-user-solid"></i><span>后台账号</span>
        </el-menu-item>
        <el-menu-item v-if="can(PERM.PERMISSIONS_MANAGE)" index="/permissions">
          <i class="el-icon-lock"></i><span>权限管理</span>
        </el-menu-item>

        <el-submenu v-if="showEntryCollectMenu" index="submenu-entry-collect">
          <template slot="title"><i class="el-icon-s-check"></i><span>资料采集</span></template>
          <el-menu-item index="/entry/personnel-class">人员分类</el-menu-item>
          <el-menu-item index="/entry/docs">资料上传</el-menu-item>
          <el-menu-item index="/entry/overview">采集汇总</el-menu-item>
        </el-submenu>
        <el-menu-item v-if="showTrainingMenu" index="/entry/training">
          <i class="el-icon-reading"></i><span>三级安全教育</span>
        </el-menu-item>
        <el-submenu v-if="showExamMenu" index="submenu-exam">
          <template slot="title"><i class="el-icon-document-checked"></i><span>线上考试</span></template>
          <el-menu-item v-if="can(PERM.EXAM_QUESTIONS_MANAGE)" index="/exam/questions">题库管理</el-menu-item>
          <el-menu-item v-else-if="can(PERM.EXAM_QUESTIONS_VIEW)" index="/exam/questions">题库选择</el-menu-item>
          <el-menu-item v-if="can(PERM.EXAM_RECORDS) || can(PERM.EXAM_TASKS)" index="/exam/scores">成绩汇总</el-menu-item>
        </el-submenu>
        <el-submenu v-if="showFileSignMenu" index="submenu-entry-sign">
          <template slot="title"><i class="el-icon-edit-outline"></i><span>文件签署</span></template>
          <el-menu-item index="/entry/contract">合同签署</el-menu-item>
          <el-menu-item index="/entry/commitment">承诺书</el-menu-item>
          <el-menu-item index="/entry/responsibility">责任书</el-menu-item>
          <el-menu-item index="/entry/sign-overview">签署汇总</el-menu-item>
        </el-submenu>
        <el-menu-item v-if="showTrainingMaterialMenu" index="/training-materials">
          <i class="el-icon-collection"></i><span>三级安全教育培训资料</span>
        </el-menu-item>
        <el-submenu v-if="showEntryTemplateMenu" index="submenu-sign-admin">
          <template slot="title"><i class="el-icon-edit-outline"></i><span>资料采集</span></template>
          <el-menu-item v-if="isSuperAdmin" index="/sign/templates">签署模板</el-menu-item>
          <el-menu-item v-if="isSuperAdmin" index="/sign/party-companies">公司信息库</el-menu-item>
          <el-menu-item v-if="isSuperAdmin" index="/entry/doc-options">资料选项维护</el-menu-item>
        </el-submenu>
        <el-menu-item v-if="showEntryCollectMenu" index="/entry/worker-archive">
          <i class="el-icon-notebook-2"></i><span>人员资料一览表</span>
        </el-menu-item>
        <el-menu-item v-if="can(PERM.FILES_VIEW)" index="/files">
          <i class="el-icon-folder-opened"></i><span>个人文件夹</span>
        </el-menu-item>
        <el-menu-item v-if="isSuperAdmin" index="/system/wechat">
          <i class="el-icon-setting"></i><span>微信配置</span>
        </el-menu-item>
        <el-menu-item v-if="can(PERM.LOGS_VIEW)" index="/logs">
          <i class="el-icon-tickets"></i><span>操作日志</span>
        </el-menu-item>
        <el-submenu index="submenu-system">
          <template slot="title"><i class="el-icon-setting"></i><span>系统设置</span></template>
          <el-menu-item index="/change-password">修改密码</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-container class="main-wrap">
      <el-header class="header">
        <div class="header-left">
          <span class="page-breadcrumb">{{ pageTitle }}</span>
        </div>
        <div class="header-right">
          <span class="user-chip">
            <i class="el-icon-user"></i>
            {{ user.realName || user.username }}
            <em>{{ roleLabel }}</em>
          </span>
          <el-button size="small" plain icon="el-icon-switch-button" @click="logout">退出</el-button>
        </div>
      </el-header>
      <el-main class="main-content">
        <router-view />
      </el-main>
      <IcpFooter variant="layout" />
    </el-container>
    </el-container>
  </div>
</template>

<script>
import IcpFooter from '../components/IcpFooter.vue'
import { PERM, hasPermission, isProjectScopedAdmin } from '../utils/permission'
import request from '../utils/request'
import { getSelectedProjectGroupName } from '../utils/projectGroup'

const ROLE_LABELS = {
  SUPER_ADMIN: '超级管理员',
  PROJECT_ADMIN: '项目管理员',
  PROJECT_SUPERVISOR: '项目监督员'
}

function normalizeProjectGroupIds(ids) {
  return (ids || [])
    .map(id => Number(id))
    .filter(id => !Number.isNaN(id))
}

const PAGE_TITLES = {
  '/dashboard': '任务总览',
  '/projects': '项目管理',
  '/users': '后台账号',
  '/permissions': '权限管理',
  '/sign/party-roles': '签署角色',
  '/sign/templates': '签署模板',
  '/sign/party-companies': '公司信息库',
  '/training-materials': '三级安全教育培训资料',
  '/entry/doc-options': '资料选项维护',
  '/sign/tasks': '签署任务',
  '/sign/records': '签署记录',
  '/exam/questions': '题库管理',
  '/exam/records': '考试记录',
  '/change-password': '修改密码',
  '/files': '个人文件夹',
  '/entry/docs': '资料上传',
  '/entry/personnel-class': '人员分类',
  '/entry/training': '三级安全教育',
  '/entry/training/1': '公司级教育',
  '/entry/training/2': '项目级教育',
  '/entry/training/3': '班组级教育1',
  '/entry/training/4': '班组级教育2',
  '/entry/contract': '合同签署',
  '/entry/commitment': '承诺书',
  '/entry/responsibility': '责任书',
  '/entry/sign-overview': '签署汇总',
  '/entry/overview': '采集汇总',
  '/entry/worker-archive': '人员资料一览表',
  '/entry/programs': '准入方案',
  '/entry/flows': '准入进度',
  '/exam/scores': '成绩汇总',
  '/system/wechat': '微信配置',
  '/logs': '操作日志'
}

export default {
  components: { IcpFooter },
  data() {
    return { PERM }
  },
  created() {
    this.syncProjectGroups()
  },
  computed: {
    user() {
      return this.$store.state.user || {}
    },
    roleLabel() {
      return ROLE_LABELS[this.user.roleCode] || this.user.roleCode
    },
    showSignMenu() {
      return this.can(PERM.SIGN_PARTY_ROLES)
        || this.can(PERM.SIGN_TEMPLATES)
        || this.can(PERM.SIGN_TASKS)
        || this.can(PERM.SIGN_RECORDS)
    },
    showExamMenu() {
      return this.can(PERM.EXAM_QUESTIONS_VIEW)
        || this.can(PERM.EXAM_QUESTIONS_MANAGE)
        || this.can(PERM.EXAM_RECORDS)
    },
    showEntryCollectMenu() {
      if (this.isSuperAdmin) return false
      return this.can(PERM.FILES_VIEW)
    },
    showFileSignMenu() {
      if (this.isSuperAdmin) return false
      return this.can(PERM.SIGN_TASKS)
    },
    showTrainingMenu() {
      if (this.isSuperAdmin) return false
      return this.can(PERM.TRAINING_TASKS)
    },
    showEntryTemplateMenu() {
      return this.isSuperAdmin
    },
    showTrainingMaterialMenu() {
      return this.isSuperAdmin
    },
    isSuperAdmin() {
      return this.user.roleCode === 'SUPER_ADMIN'
    },
    showProjectGroupSelect() {
      return isProjectScopedAdmin(this.user) && this.projectGroupOptions.length > 0
    },
    projectGroupOptions() {
      const ids = normalizeProjectGroupIds(this.user.projectGroupIds)
      const names = this.user.projectGroupNames || []
      return ids.map((id, index) => ({
        id,
        name: (names[index] || '').trim() || `项目组${index + 1}`
      }))
    },
    selectedProjectGroupId() {
      return this.$store.state.selectedProjectGroupId
    },
    adminDisplayName() {
      return (this.user.realName || this.user.username || '').trim()
    },
    logoText() {
      if (isProjectScopedAdmin(this.user)) {
        const group = this.showProjectGroupSelect
          ? getSelectedProjectGroupName(this.$store)
          : (this.user.projectGroupName || '').trim()
        const name = (this.user.realName || this.user.username || '').trim()
        if (group && name) return group + ' · ' + name
        return group || name || '入场安全管理'
      }
      return '入场安全管理'
    },
    forcePasswordMode() {
      const user = this.user
      return !!(user.mustChangePassword && isProjectScopedAdmin(user))
    },
    pageTitle() {
      if (this.$route.path === '/exam/questions' && !this.can(PERM.EXAM_QUESTIONS_MANAGE)) {
        return '题库选择'
      }
      return PAGE_TITLES[this.$route.path] || '管理后台'
    },
    menuActivePath() {
      const path = this.$route.path
      if (path.startsWith('/entry/training/')) {
        return '/entry/training'
      }
      return path
    }
  },
  methods: {
    async syncProjectGroups() {
      if (!isProjectScopedAdmin(this.user)) return
      if (normalizeProjectGroupIds(this.user.projectGroupIds).length > 0) return
      try {
        const res = await request.get('/auth/my-project-groups', { silent: true })
        const ids = normalizeProjectGroupIds((res.data && res.data.ids) || [])
        const names = (res.data && res.data.names) || []
        if (!ids.length) return
        this.$store.commit('setAuth', {
          ...this.user,
          token: this.$store.state.token,
          projectGroupIds: ids,
          projectGroupNames: names,
          projectGroupName: names.join('、')
        })
      } catch (e) {
        /* 401 等由 request 拦截器处理 */
      }
    },
    can(code) {
      return hasPermission(this.user, code)
    },
    handleMenuSelect(index) {
      if (typeof index !== 'string' || !index.startsWith('/')) return
      if (this.$route.path === index) return
      this.$router.push(index).catch(() => {})
    },
    onProjectGroupChange(groupId) {
      if (groupId == null || groupId === this.selectedProjectGroupId) return
      this.$store.commit('setSelectedProjectGroupId', groupId)
      this.$message.success('已切换项目组')
      window.location.reload()
    },
    logout() {
      this.$confirm('确定退出登录？', '退出确认', { type: 'warning' })
        .then(() => {
          this.$store.commit('logout')
          this.$router.replace('/login')
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.layout-host {
  height: 100vh;
  width: 100%;
}
.layout-root {
  height: 100vh;
  width: 100%;
}
.aside {
  background: linear-gradient(180deg, #243b55 0%, #1a2a3a 100%);
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 300;
  flex-shrink: 0;
}
.logo {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 20px 16px 16px;
  color: #fff;
}
.logo-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.project-group-select {
  width: 100%;
}
.project-group-select >>> .el-input__inner {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.25);
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  height: 32px;
  line-height: 32px;
}
.project-group-select >>> .el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.7);
}
.project-group-select >>> .el-input.is-disabled .el-input__inner {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.85);
}
.project-group-select >>> .el-input__suffix {
  color: rgba(255, 255, 255, 0.85);
}
.logo-admin {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.3;
  word-break: break-all;
}
.logo-badge {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(64, 158, 255, 0.25);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
}
.logo-text {
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
  line-height: 1.35;
  word-break: break-all;
}
.side-menu {
  border-right: none;
  flex: 1;
}
.side-menu >>> .el-menu-item.is-active {
  background: rgba(64, 158, 255, 0.22) !important;
  border-radius: 8px;
  margin: 2px 8px;
  width: calc(100% - 16px);
}
.side-menu >>> .el-menu-item,
.side-menu >>> .el-submenu__title {
  height: 46px;
  line-height: 46px;
}
.main-wrap {
  flex: 1;
  min-width: 0;
  background: #f0f2f5;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  height: 56px !important;
  padding: 0 20px;
}
.page-breadcrumb {
  color: #606266;
  font-size: 14px;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}
.user-chip {
  font-size: 14px;
  color: #303133;
}
.user-chip em {
  margin-left: 8px;
  font-style: normal;
  color: #909399;
  font-size: 12px;
}
.main-content {
  padding: 20px;
}
.force-password-shell {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
  padding: 24px;
  box-sizing: border-box;
}
</style>
